import { isString } from "../utils/schemaUtils";

export interface LinearUser {
  id: string;
  name: string;
  // The @-handle Linear uses in mentions.
  displayName: string;
  email?: string;
  active: boolean;
}

const isLinearUser = (v: unknown): v is LinearUser => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.name) &&
    isString(r.displayName) &&
    (r.email === undefined || isString(r.email)) &&
    typeof r.active === "boolean"
  );
};

export interface LinearUsersPayload {
  type: "linear_users";
  users: LinearUser[];
}

export const parseLinearUsersPayload = (v: unknown): LinearUsersPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_users") return null;
  if (!Array.isArray(r.users) || !r.users.every(isLinearUser)) return null;
  return {
    type: "linear_users",
    users: r.users,
  };
};
